exports.cs = {
  CHART_RANGE: {
    LABEL: 'Zobrazit data za uplynulý |||| Zobrazit data za uplynulé |||| Zobrazit data za uplynulých',
    LABEL_ALL: 'Zobrazit data',
    LABEL_FREE: 'Zobrazit data za uplynulý',
    FROM: 'od',
    TO: 'do',
    WEEKS: 'týden |||| týdny |||| týdnů',
    MONTHS: 'měsíc |||| měsíce |||| měsíců',
    YEARS: 'rok |||| roky |||| let',
    ALL: 'od založení',
    FREE: 'volný rozsah'
  }
}
